import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconAlertFill.tsx
const IconAlertFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "m17.154 4 12.702 22a1.334 1.334 0 0 1-1.155 2H3.298a1.334 1.334 0 0 1-1.155-2L14.845 4a1.334 1.334 0 0 1 2.31 0m-2.488 17.333V24h2.667v-2.667zm0-9.333v6.667h2.667V12z"
	})]
});
var IconAlertFill_default = forwardRef(IconAlertFill);
//#endregion
export { IconAlertFill_default as default };
